import React from "react";
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";
import "./PhoneNumber.css";
import parsePhoneNumber from "libphonenumber-js/max";

export function sanitizePhone(phoneNumber) {
  return phoneNumber.replace(/[\D]+/g, "");
}

export function parsePhone(phoneNumber) {
  const sanitized = "+" + sanitizePhone(phoneNumber);
  const phone = parsePhoneNumber(sanitized);
  return {
    isValid: phone?.isValid(),
    countryCode: phone?.countryCallingCode,
    fullPhoneNumber: phone?.number,
    nationalPhoneNumber: phone?.nationalNumber,
  };
}

const PhoneNumber = (props) => {
  let innerPhoneChange = (
    isValid,
    nationalPhoneNumber,
    { dialCode },
    fullPhoneNumber
  ) => {
    let data = {
      isValid,
      countryCode: dialCode,
      nationalPhoneNumber: nationalPhoneNumber.replace(
        /[^0-9٠-٩۰-۹ ()-]/gi,
        ""
      ),
      fullPhoneNumber: sanitizePhone(fullPhoneNumber),
    };
    props.onPhoneChange(data);
  };
  return (
    <IntlTelInput
      containerClassName="intl-tel-input"
      inputClassName="form-control"
      preferredCountries={["ae", "eg", "pk", "sa"]}
      separateDialCode={true}
      onPhoneNumberChange={innerPhoneChange}
    />
  );
};

export default PhoneNumber;
